export default {"src":"/_next/static/media/SubDesc7.3ead92eb.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};